import { createSlice } from "@reduxjs/toolkit";


export const initialState = {
  user: "",
  error: ""
};

const LoginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      return {
        ...state,
        user: action.payload.data
      }
    },
    logoutUserSuccess(state, action) {
      return {
        ...initialState
      }
    },
    initializeFromSessionSuccess(state, action) {
      return {
        ...state,
        user: action.payload
      }
    },
    resetState: (state) => {return {...initialState}},
  },
});

export const {
  loginSuccess,
  logoutUserSuccess,
  resetState,
  initializeFromSessionSuccess,
} = LoginSlice.actions

export default LoginSlice.reducer;